<ngx-loading-bar color="#fff" [includeSpinner]="false"></ngx-loading-bar>
<app-header *ngIf="!router.url.includes('room')"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="!router.url.includes('room')"></app-footer>
